<template>
  <div>
      <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
          <navcon></navcon>
      </div>
      <div class="index-page"></div>

      <div class="main-con html" style="text-align: center;">
          <img class="certPath" :src="certPath">
      </div>

      <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
          <footers></footers>
      </el-footer>
  </div>
</template>

<script>
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
export default {
  components:{
    navcon,
    footers
  },
  data() {
    return {
      certPath:'',
    }
  },
  created(){
    this.certPath = this.$route.query.certPath;
  }
}
</script>

<style scoped>
  .certPath{
    padding: 40px 0;
    max-width: 85%;
  }

</style>


// WEBPACK FOOTER //
// src/views/index/preview.vue